import { ROUTE_MENTOR_PATH } from 'routes';
import { Home, User, MessageSquareText } from 'lucide-react';
import { useSelector } from 'react-redux';
import { useMemo } from 'react';

const useMentorRows = (rolePath) => {
  const user = useSelector(state => state.i18n.user);
  const literals = useSelector(state => state.i18n.literals.leftMenu);

  const navRows = useMemo(() => (rolePath === 'mentor' ? {
    upper: [
      {
        path: ROUTE_MENTOR_PATH.HOME,
        to: ROUTE_MENTOR_PATH.HOME,
        name: literals.summary,
        icon: Home,
        exact: true,
      },
      {
        path: ROUTE_MENTOR_PATH.EDIT_MENTOR,
        to: ROUTE_MENTOR_PATH.setEditMentor(user?.mentor?.id),
        name: literals.profile,
        icon: User,
      },
      {
        path: ROUTE_MENTOR_PATH.MENTORINGS,
        to: ROUTE_MENTOR_PATH.MENTORINGS,
        name: literals.mentorings,
        icon: MessageSquareText,
      },
    ],
  // eslint-disable-next-line react-hooks/exhaustive-deps
  } : {}), [rolePath, user?.mentor?.id]);

  return navRows;
};

export default useMentorRows;
